import { Button, TextField, Typography } from "@material-ui/core";
import { Formik } from "formik";
import { get } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "../../../../../../components/Dialog";
import {
  getFactorClient,
  getFreezeActionPending,
  unfreezeReceivables
} from "../../../../../../modules/factoringClient";
import {
  closeDialog,
  getDialog,
  openSnackbar
} from "../../../../../../modules/ui";

export const CONFIRM_UNFREEZE_DIALOG_VARIANT = "confirm-unfreeze-receivables";

interface FormValues {
  reason: string;
}

const ConfirmUnfreezeDialog = (): JSX.Element => {
  const dispatch = useDispatch();
  const dialog = useSelector(getDialog);
  const factoring: any = useSelector(getFactorClient);
  const pending = useSelector(getFreezeActionPending);

  const open = dialog.variant === CONFIRM_UNFREEZE_DIALOG_VARIANT;
  const factoringId = get(factoring, "id");
  const clientName =
    get(factoring, "company_profile.name") ||
    get(factoring, "user.email") ||
    "this client";

  const handleClose = (): void => {
    dispatch(closeDialog());
  };

  const validate = (values: FormValues): { reason?: string } => {
    if (!values.reason || values.reason.trim().length === 0) {
      return { reason: "Reason is required." };
    }
    return {};
  };

  return (
    <Dialog open={open} fullWidth maxWidth="sm" onClose={handleClose}>
      <Formik<FormValues>
        enableReinitialize
        initialValues={{ reason: "" }}
        validate={validate}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          try {
            await dispatch(
              unfreezeReceivables(factoringId, values.reason.trim())
            );
            dispatch(openSnackbar("success", "Factored receivables unfrozen."));
            resetForm();
            handleClose();
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          errors,
          touched,
          isValid
        }): JSX.Element => (
          <>
            <DialogTitle onClose={handleClose}>
              Unfreeze Factored Receivables
            </DialogTitle>
            <DialogContent>
              <Typography paragraph>
                You are about to{" "}
                <strong>unfreeze factored receivables</strong> for{" "}
                <strong>{clientName}</strong>. All cash application, purchase,
                and obligation operations will be re-enabled immediately.
              </Typography>
              <Typography paragraph color="error">
                <strong>
                  Ensure the buyout wire has been confirmed before unfreezing.
                </strong>
              </Typography>
              <TextField
                name="reason"
                label="Reason / Notes"
                placeholder="e.g. Buyout wire confirmed — safe to unfreeze"
                value={values.reason}
                onChange={handleChange}
                onBlur={handleBlur}
                error={Boolean(touched.reason && errors.reason)}
                helperText={touched.reason && errors.reason}
                multiline
                rowsMax={5}
                fullWidth
                required
                margin="normal"
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} disabled={pending}>
                Cancel
              </Button>
              <Button
                variant="contained"
                style={{ backgroundColor: "#2e7d32", color: "#fff" }}
                onClick={(): void => handleSubmit()}
                disabled={pending || !isValid}
              >
                {pending ? "Unfreezing..." : "Confirm Unfreeze"}
              </Button>
            </DialogActions>
          </>
        )}
      </Formik>
    </Dialog>
  );
};

export default ConfirmUnfreezeDialog;
